(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-catalog-layout"] && !Shopify.designMode) return;
  try {
    class MaisonCatalogLayout extends HTMLElement {
    static observedAttributes = ['data-desktop', 'data-tablet', 'data-mobile'];
    #choices = {};
    #frame = 0;
    #mobile = window.matchMedia('(max-width: 749px)');
    #tablet = window.matchMedia('(max-width: 1199px)');
    #contentObserver = new MutationObserver(() => this.#schedule());
    #styleObserver = new MutationObserver(() => this.#schedule());
    #resizeObserver = new ResizeObserver(() => this.#schedule());

    connectedCallback() {
      if (this.dataset.designMode !== 'true') {
        for (const mode of ['desktop', 'tablet', 'mobile']) {
          try {
            const saved = Number(sessionStorage.getItem(`tiffany-catalog-columns-${mode === 'mobile' ? 'v4' : 'v3'}-${mode}`));
            if (this.#allowed(mode).includes(saved)) this.#choices[mode] = saved;
          } catch {}
        }
      }
      this.addEventListener('click', this.#handleClick);
      this.#mobile.addEventListener('change', this.#schedule);
      this.#tablet.addEventListener('change', this.#schedule);
      this.#contentObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
      this.#styleObserver.observe(this, { attributes: true, attributeFilter: ['style'] });
      this.#resizeObserver.observe(this);
      this.#schedule();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.#mobile.removeEventListener('change', this.#schedule);
      this.#tablet.removeEventListener('change', this.#schedule);
      this.#contentObserver.disconnect();
      this.#styleObserver.disconnect();
      this.#resizeObserver.disconnect();
      cancelAnimationFrame(this.#frame);
      this.#frame = 0;
    }

    attributeChangedCallback() {
      if (!this.isConnected) return;
      if (this.dataset.designMode === 'true') this.#choices = {};
      this.#schedule();
    }

    #allowed(mode) {
      return mode === 'mobile' ? [1, 2] : [2, 3, 4];
    }

    #mode() {
      return this.#mobile.matches ? 'mobile' : this.#tablet.matches ? 'tablet' : 'desktop';
    }

    #selected(mode) {
      const selected = this.#choices[mode] ?? Number(this.dataset[mode]);
      return this.#allowed(mode).includes(selected) ? selected : mode === 'mobile' ? 1 : 4;
    }

    #handleClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[data-columns]');
      if (!button || !this.contains(button)) return;
      const mode = button.closest('[data-columns-mode]')?.dataset.columnsMode;
      const columns = Number(button.dataset.columns);
      if (mode !== this.#mode() || !this.#allowed(mode).includes(columns)) return;
      this.#choices[mode] = columns;
      if (this.dataset.designMode !== 'true') {
        try { sessionStorage.setItem(`tiffany-catalog-columns-${mode === 'mobile' ? 'v4' : 'v3'}-${mode}`, String(columns)); } catch {}
      }
      this.#refresh();
    };

    #schedule = () => {
      if (this.#frame || !this.isConnected) return;
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        if (this.isConnected) this.#refresh();
      });
    };

    #refresh() {
      const mode = this.#mode();
      this.dataset.columns = String(this.#selected(mode));
      const enabled = this.querySelector(`[data-columns-mode="${mode}"]`);
      const value = enabled ? String(this.#selected(mode)) : '';
      if (this.style.getPropertyValue('--mc-view-columns') !== value) {
        if (value) this.style.setProperty('--mc-view-columns', value);
        else this.style.removeProperty('--mc-view-columns');
      }
      for (const group of this.querySelectorAll('[data-columns-mode]')) {
        const selected = this.#selected(group.dataset.columnsMode);
        for (const button of group.querySelectorAll('button[data-columns]')) {
          const pressed = String(Number(button.dataset.columns) === selected);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        }
      }
      if (!enabled) return;
      for (const image of this.querySelectorAll('.product-grid .product-media__image')) {
        const width = Math.ceil(image.getBoundingClientRect().width);
        if (width > 0 && image.sizes !== `${width}px`) image.sizes = `${width}px`;
      }
    }
  }
  if (!customElements.get('maison-catalog-layout')) customElements.define('maison-catalog-layout', MaisonCatalogLayout);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maison-mobile-sort"] && !Shopify.designMode) return;
  try {
    class MaisonMobileSort extends HTMLElement {
    #form;

    connectedCallback() {
      this.addEventListener('change', this.#change);
      this.#connectForm();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#change);
      this.#form?.removeEventListener('formdata', this.#formData);
    }

    async #connectForm() {
      await customElements.whenDefined('sorting-filter-component');
      if (!this.isConnected) return;
      this.#form = document.getElementById(this.dataset.formId);
      this.#form?.addEventListener('formdata', this.#formData);
    }

    #formData = (event) => {
      if (window.innerWidth >= 750) return;
      const sorter = this.#form?.querySelector('sorting-filter-component');
      const control = sorter?.dataset.shouldUseSelectOnMobile === 'true'
        ? sorter.querySelector('select[name="sort_by"]')
        : sorter?.querySelector('input[name="sort_by"]:checked');
      if (control?.value) event.formData.set('sort_by', control.value);
    };

    #change = async (event) => {
      if (!(event.target instanceof HTMLSelectElement)) return;
      const value = event.target.value;
      await customElements.whenDefined('sorting-filter-component');
      if (!this.isConnected) return;
      const form = document.getElementById(this.dataset.formId);
      const sorter = form?.querySelector('sorting-filter-component');
      if (!sorter || typeof sorter.updateFilterAndSorting !== 'function') return;
      const select = sorter.querySelector('select[name="sort_by"]');
      const radios = [...sorter.querySelectorAll('input[name="sort_by"]')];
      const radio = radios.find(input => input.value === value);
      if (!radio) return;
      // Keep both native representations in sync for later filter changes/resizes.
      radio.checked = true;
      if (select) select.value = value;
      const control = sorter.dataset.shouldUseSelectOnMobile === 'true' ? select : radio;
      if (control) sorter.updateFilterAndSorting({ target: control });
    };
  }
  if (!customElements.get('maison-mobile-sort')) customElements.define('maison-mobile-sort', MaisonMobileSort);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maison-refinements"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (window.Shopify?.designMode || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('[data-maison-direct-menu] a[href]') : null;
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || !['http:', 'https:'].includes(destination.protocol)) return;
    if (destination.pathname === location.pathname && destination.search === location.search && destination.hash) return;
    event.preventDefault();
    let transitionStyle = document.getElementById('tm-direct-navigation');
    if (!transitionStyle) {
      transitionStyle = document.createElement('style');
      transitionStyle.id = 'tm-direct-navigation';
      transitionStyle.textContent = '@view-transition { navigation: none; }';
      document.head.appendChild(transitionStyle);
    }
    document.getElementById('view-transition-render-blocker')?.remove();
    window.location.assign(destination.href);
  }, true);

  const maisonCloseMenu = (details, restoreFocus = false) => {
    details.open = false;
    if (restoreFocus) details.querySelector(':scope > summary')?.focus();
  };
  const maisonInitMenus = (root = document) => {
    root.querySelectorAll('[data-maison-menu-close]').forEach(button => { button.hidden = false; });
  };
  if (!customElements.get('maison-navigation-menu')) {
    customElements.define('maison-navigation-menu', class extends HTMLElement {
      connectedCallback() { maisonInitMenus(this); }
    });
  }
  maisonInitMenus();
  document.addEventListener('DOMContentLoaded', () => maisonInitMenus());
  document.addEventListener('shopify:section:load', event => maisonInitMenus(event.target));
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-maison-menu-close]');
    if (close) maisonCloseMenu(close.closest('details'), true);
    document.querySelectorAll('.maison-mobile-menu[open], .maison-desktop-menu__item > .maison-submenu[open]').forEach(details => {
      if (!details.parentElement.contains(event.target)) maisonCloseMenu(details);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.maison-submenu[open], .maison-mobile-menu[open]');
    if (details) { event.preventDefault(); maisonCloseMenu(details, true); }
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.maison-desktop-menu__item > .maison-submenu')) return;
    const menu = details.closest('.maison-desktop-menu');
    menu?.querySelectorAll('.maison-desktop-menu__item > .maison-submenu[open]').forEach(other => {
      if (other !== details) maisonCloseMenu(other);
    });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tiffany-cookie-banner"] && !Shopify.designMode) return;
  try {
    const copy = document.getElementById('TiffanyCookieCopy');
  if (copy) {
    const title = copy.content.querySelector('[data-cookie-title]')?.textContent.trim();
    const body = copy.content.querySelector('[data-cookie-body]')?.textContent.trim();
    const updateCopy = () => {
      const heading = document.getElementById('shopify-pc__banner__body-title');
      const policy = document.getElementById('shopify-pc__banner__body-policy-link');
      const paragraph = policy?.closest('p');
      if (!heading || !paragraph || !title || !body) return false;
      heading.textContent = title;
      paragraph.replaceChildren(document.createTextNode(body + ' '), policy);
      document.getElementById('shopify-pc__banner')?.setAttribute('data-tiffany-copy', 'true');
      return true;
    };
    if (!updateCopy()) {
      const observer = new MutationObserver(() => {
        if (updateCopy()) observer.disconnect();
      });
      observer.observe(document.body, {childList:true, subtree:true});
      window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tiffany-measurement-line"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tiffany-measurement-line')) {
    class TiffanyMeasurementLine extends HTMLElement {
      #resize = new ResizeObserver(() => this.#schedule());
      #position = new MutationObserver(() => this.#schedule());
      #visible = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) this.#schedule(); }, { rootMargin: '200px' });
      #mobile = matchMedia('(max-width: 749px)');
      #frame = 0;
      #boundary;
      connectedCallback() {
        this.#boundary = this.closest('product-card, .ta-card, .tr-card__body') || this.parentElement;
        this.#resize.observe(this.parentElement);
        if (this.#boundary !== this.parentElement) this.#resize.observe(this.#boundary);
        this.#position.observe(this.#boundary, { attributes: true, attributeFilter: ['style'] });
        this.#visible.observe(this);
        this.#mobile.addEventListener('change', this.#schedule);
        document.fonts.addEventListener('loadingdone', this.#schedule);
        document.fonts.ready.then(this.#schedule);
        this.#schedule();
      }
      disconnectedCallback() {
        this.#resize.disconnect();
        this.#position.disconnect();
        this.#visible.disconnect();
        this.#mobile.removeEventListener('change', this.#schedule);
        document.fonts.removeEventListener('loadingdone', this.#schedule);
        cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }
      #schedule = () => {
        if (!this.isConnected || this.#frame) return;
        this.#frame = requestAnimationFrame(() => { this.#frame = 0; this.#fit(); });
      };
      #fit() {
        if (!this.#mobile.matches || !this.isConnected) return;
        this.style.removeProperty('font-size');
        this.textContent = this.dataset.compact;
        const rect = this.getBoundingClientRect();
        const boundary = this.#boundary.getBoundingClientRect();
        const inset = parseFloat(getComputedStyle(this.#boundary).paddingRight) || 0;
        let available = boundary.right - inset - rect.left - 2;
        const parentStyle = getComputedStyle(this.parentElement);
        if (this.closest('.mc-catalog') && parentStyle.justifyContent === 'center') {
          const iconStyle = getComputedStyle(this.parentElement, '::before');
          available = this.parentElement.clientWidth
            - (parseFloat(parentStyle.paddingLeft) || 0)
            - (parseFloat(parentStyle.paddingRight) || 0)
            - (parseFloat(iconStyle.width) || 0)
            - (parseFloat(parentStyle.columnGap) || 0) - 2;
        }
        if (available <= 0 || rect.width <= 0) return;
        const base = parseFloat(getComputedStyle(this.parentElement).fontSize);
        if (base * available / rect.width < Math.min(base, 11)) this.textContent = this.dataset.tight;
        const natural = this.getBoundingClientRect().width;
        const size = Math.floor(Math.min(base, base * available / natural) * 20) / 20;
        this.style.fontSize = `${size}px`;
      }
    }
    customElements.define('tiffany-measurement-line', TiffanyMeasurementLine);
  }
  } catch(e) { console.error(e); }
})();

})();
